(function () {
  "use strict";

  var panel = document.querySelector("[data-estimator]");
  if (!panel) return;

  var amountInput = panel.querySelector("[data-estimator-amount]");
  var amountValue = panel.querySelector("[data-estimator-amount-value]");
  var termSelect = panel.querySelector("[data-estimator-term]");
  var purposeSelect = panel.querySelector("[data-estimator-purpose]");
  var resultEl = panel.querySelector("[data-estimator-result]");

  /* Illustrative APR ranges by category — not an offer, not a quote. */
  var rateRanges = {
    personal: [0.08, 0.24],
    debt: [0.07, 0.2],
    home: [0.06, 0.18],
    auto: [0.05, 0.15],
    business: [0.09, 0.25],
    emergency: [0.1, 0.3]
  };

  function formatCurrency(value) {
    return "$" + Math.round(value).toLocaleString("en-US");
  }

  function monthlyPayment(principal, annualRate, months) {
    var r = annualRate / 12;
    if (r === 0) return principal / months;
    var factor = Math.pow(1 + r, months);
    return (principal * r * factor) / (factor - 1);
  }

  function recalc() {
    var amount = parseFloat(amountInput.value) || 0;
    var months = parseInt(termSelect.value, 10) || 24;
    var purpose = purposeSelect.value || "personal";
    var range = rateRanges[purpose] || rateRanges.personal;

    if (amountValue) {
      amountValue.textContent = formatCurrency(amount);
    }

    var low = monthlyPayment(amount, range[0], months);
    var high = monthlyPayment(amount, range[1], months);

    if (resultEl) {
      resultEl.textContent = formatCurrency(low) + " \u2013 " + formatCurrency(high);
      /* Sharp flash-highlight instead of a scale-pulse — force reflow to re-trigger. */
      resultEl.classList.remove("is-updated");
      void resultEl.offsetWidth;
      resultEl.classList.add("is-updated");
    }
  }

  [amountInput, termSelect, purposeSelect].forEach(function (el) {
    if (el) el.addEventListener("input", recalc);
  });

  recalc();
})();
